import React from 'react'
import {colors} from "../../utils/styles"

export class BigRadio extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
        <div style={{
          fontSize: '18px',
          fontWeight: 600,
          color: colors.offBlack,
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
             onClick={this.props.onClick}
        >
          <img src={'images/' + (this.props.selected ? 'bradio-selected.svg' : 'bradio.svg')}
               style={{}}/>
          <div style={{width: 10}}/>
          {this.props.label}
        </div>
    )
  }
}

export default BigRadio